(() => {
  'use strict';

  document.querySelectorAll('[data-yvicor-cookie-preferences]').forEach((control) => {
    if (control.dataset.cookiePreferencesReady === 'true') return;
    const button = control.querySelector('[data-cookie-preferences-open]');
    const error = control.querySelector('[data-cookie-preferences-error]');
    if (!button || !error) return;
    control.dataset.cookiePreferencesReady = 'true';

    let opening = false;
    button.addEventListener('click', async () => {
      if (opening) return;
      error.hidden = true;
      const banner = window.privacyBanner;
      if (!banner || typeof banner.showPreferences !== 'function') {
        error.hidden = false;
        return;
      }

      opening = true;
      button.setAttribute('aria-busy', 'true');
      try {
        // Let Shopify capture the opener and manage the modal's focus lifecycle.
        button.focus({ preventScroll: true });
        await banner.showPreferences();
      } catch {
        error.hidden = false;
      } finally {
        opening = false;
        button.removeAttribute('aria-busy');
      }
    });
  });
})();
